
<template>
  <div>

    <div class="container-fluid">
      <div class="row ">
        <div class="col-12 p-0">
          <div class="login-card">
            <div>
              <div>
                <a class="logo">
                  <img class="img-fluid for-light" src="../assets/images/logo/login/login_vue.png" height="160" width="250" alt="looginpage" />
                  <img class="img-fluid for-dark" src="../assets/images/logo/login/login_vue2.png" height="160" width="250" alt="looginpage" />
                </a>
              </div>
              <div class="login-main">
                <form class="theme-form">
                  <h4>Sign in to account</h4>
                  <p>Enter your email & password to login</p>
                  <div class="form-group">
                    <label class="col-form-label">Username</label>
                    <input class="form-control" type="text" required="" placeholder="Username"
                      v-model="user.username.value">
                    <span class="validate-error" v-if="user.username.errormsg">{{user.username.errormsg }}</span>

                  </div>
                  <div class="form-group">
                    <label class="col-form-label">Password</label>
                    <div class="form-input position-relative">
                      <input class="form-control" :type="showPassword ? 'text' : 'password'" name="login[password]" required=""
                        placeholder="*********" v-model="user.password.value">
                      <span class="validate-error" v-if="user.password.errormsg">{{ user.password.errormsg }}</span>
                      <div class="show-hide position-absolute top-50 end-0 translate-middle-y pe-3" style="cursor: pointer;" @click="showPassword = !showPassword">
                        <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                  <div class="form-group mb-0">
                    <div class="text-end mt-3">
                      <button class="btn btn-primary btn-block w-100" type="submit" @click.prevent="login">Sign
                        in</button>

                    </div>
                  </div>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { post } from '@/utils/api.js';
import { routes } from '../constants/routes.js';
import Swal from '@/utils/swal';

const router = useRouter();

const user = reactive({
  username: { value: '', errormsg: '' },
  password: { value: '', errormsg: '' }
});

const showPassword = ref(false);

const login = () => {
  if (!user.password.value || user.password.value.length < 6) {
    user.password.errormsg = 'Password will be atleast 6 characters';
  } else {
    user.password.errormsg = '';
  }

  if (!user.username.value) {
    user.username.errormsg = 'Username is required';
  } else {
    user.username.errormsg = '';
  }

  if(user.username.errormsg || user.password.errormsg){
    return;
  }

  const data = {
    username: user.username.value, 
    password: user.password.value
  };

  post(routes.Login, data, true)
    .then((response) => {
      if (response.status === 200) {
        var responseData = response.data.data.details;
        if (responseData.token) 
        {
          localStorage.setItem('speed_tech', JSON.stringify(responseData));   
          const token = responseData.token;
          if (token) {
            Swal.fire("", response.data.message, "success").then(() => {
              router.push({ name: "dashboard" });
            });
          } else {
            Swal.fire("", "Failed to fetch token, please try again", "error");
          }    
        } else {
            Swal.fire("", "Failed to fetch token, please try again", "error");
        }

      } else {
        Swal.fire('', response.data.message, 'error');
      }
    })
    .catch((error) => {

      if (error.response?.status === 422) {
          const messages = error.response.data?.message || {};
          if (messages.username) {
            user.username.errormsg = messages.username[0];
            Swal.fire("", user.username.errormsg, "error");
          } else if (messages.password) {
            user.password.errormsg = messages.password[0];
            Swal.fire("", user.password.errormsg, "error");
          } else {
            Swal.fire("", error.response.data.message, "error");
          }

      } else if (error.response?.status === 500) {
        Swal.fire("", error.response.statusText, "error");

      } else if (error.response?.status === 401) {
        Swal.fire("", error.response.statusText, "error");
        router.push({ name: "login" });

      } else {
        Swal.fire("", "Failed to fetch token, please login again", "error");
        router.push({ name: 'login' });
      }
  
    });
};
</script>

